import { CelebrationOverlay } from '../components/CelebrationOverlay';
import { useCelebrationStore } from '../hooks/useCelebration';
import { useAchievementRealtime } from '../hooks/useAchievementRealtime';
import { useAuth } from '@features/auth';

/**
 * Provider that renders the celebration overlay globally.
 * Also subscribes to real-time achievement events for the current user.
 * Add this at the top level of your app (e.g., in App.tsx).
 */
export function CelebrationProvider({ children }: { children: React.ReactNode }) {
  const currentCelebration = useCelebrationStore((state) => state.currentCelebration);
  const completeCelebration = useCelebrationStore((state) => state.completeCelebration);
  const { user } = useAuth();

  // Subscribe to real-time achievement events for celebration animations
  useAchievementRealtime(user?.id);

  return (
    <>
      {children}
      <CelebrationOverlay
        celebration={currentCelebration}
        onComplete={completeCelebration}
      />
    </>
  );
}
